<form [formGroup]="form" (ngSubmit)="saveChanges()">

  <div class="modal-header">
    <h4 class="modal-title d-flex"> 
      <!-- გამოჩენა -->
      <div class="form-check visibility-toggle p-0 mt-1 mx-1">
        <input
          id="visible"
          class="form-check-input d-none"
          type="checkbox"
          formControlName="visible"
        />
        <label class="form-check-label cursor-pointer" for="visible">
          <i class="fi fi-rs-eye show-icon"></i>
          <i class="fi fi-rr-eye-crossed hide-icon"></i>
        </label>
      </div>
      <span *ngIf="this.menuItem?.id">მენიუს რედაქტირება</span>
      <span *ngIf="!this.menuItem?.id">მენიუს დამატება</span>
    </h4>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
  </div>

  <div class="modal-body">
  

    <!-- მენიუს დასახელება -->
    <div class="form-floating mb-3">
      <input
        formControlName="title"
        type="text"
        id="title"
        class="form-control"
        placeholder="მენიუს დასახელება"
      />
      <label for="title">მენიუს დასახელება</label>

      <div class="invalid-feedback d-block" *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
        <div *ngIf="form.get('title')?.errors?.['required']">ველი სავალდებულოა</div>
        <div *ngIf="form.get('title')?.errors?.['minlength']">მინიმუმ 2 სიმბოლო</div>
      </div>

      <div class="text-danger small" *ngIf="apiErrors?.title">{{ apiErrors.title }}</div>
    </div>

    <div class="row">

      <!-- გვერის ტიპი -->
      <div class="col-md-4">
      
        <div class="form-floating mb-3">
          <select formControlName="pageType" id="pageType" class="form-select">
            <option value="1">სტატიკური</option>
            <option value="36">სია</option>
            <option value="40">გალერეა</option>
            <option value="8">ფორმა</option>
            <option value="35">კითხვები და პასუხები</option>
            <!-- <option value="27">სასარგებლო ბმულები</option> -->
          </select>
          <label for="pageType">გვერის ტიპი</label>
          <div class="invalid-feedback d-block"
              *ngIf="form.get('pageType')?.invalid && form.get('pageType')?.touched">
            გვერის ტიპი სავალდებულოა
          </div>
        </div>
      </div>

      <!-- სტატუსი -->
      <div class="col-md-4">
        <div class="form-floating mb-3">
          <select formControlName="status" id="status" class="form-select">
            <option value="1">აქტიური</option>
            <option value="0">არააქტიური</option>
          </select>
          <label for="status">სტატუსი</label>
          <div class="invalid-feedback d-block" *ngIf="form.get('status')?.invalid && form.get('status')?.touched">
            სტატუსი სავალდებულოა
          </div>
          <div class="text-danger small" *ngIf="apiErrors?.status">{{ apiErrors.status }}</div>
        </div>
      </div>

      <!-- მენიუს პოზიცია -->
      <div class="col-md-4">
        <div class="form-floating mb-3">
          <select formControlName="position" id="position" class="form-select">
            <option value="1">ზედა მენიუ</option>
            <option value="2">მთავარი მენიუ</option>
            <option value="3">ქვედა მენიუ</option>
            <option value="10">დამალული</option>
          </select>
          <label for="position">მენიუს პოზიცია</label>

          <div class="invalid-feedback d-block" *ngIf="form.get('position')?.invalid && form.get('position')?.touched">
              მენიუს პოზიცია სავალდებულოა
          </div>
        </div>
      </div>

    </div>
 
    <div class="mb-3">
      <app-parent-menu-select
        [allMenu]="allMenuForParentSelect"
        [filterPos]="form.get('position')?.value"
        [selectedMenuId]="menuItem?.parent_id ?? menuItem?.up_id ?? 0"
        [excludeMenuId]="menuItem?.id"
        (selected)="onSelectParent($event)">
      </app-parent-menu-select>
    </div>

    <div class="form-check form-switch mt-0 pt-0 mb-3">
      <input class="form-check-input" type="checkbox" role="switch" id="isRedirect" formControlName="isRedirect">
      <label class="form-check-label" for="isRedirect">გადამისამართება</label>
    </div>
    
    <div class="row" *ngIf="form.get('isRedirect')?.value">
      <!-- URL -->
      <div class="col-md-8">

        <div class="form-floating mb-3">
          <input formControlName="url" id="url" type="text" class="form-control" placeholder="URL" />
          <label for="url">http://</label>
          <div class="invalid-feedback d-block"
              *ngIf="form.get('url')?.invalid && form.get('url')?.touched">
            URL სავალდებულოა
          </div>
          <div class="text-danger small" *ngIf="apiErrors?.url">{{ apiErrors.url }}</div>
        </div>
       </div>

       <!-- ფანჯარა -->
       <div class="col-md-4">
        <div class="form-floating mb-3">
          <select formControlName="target" id="target" class="form-select">
            <option value="_self">იმავე ფანჯარაში</option>
            <option value="_blank">ახალ ფანჯარაში</option>
          </select>
          <label for="target">ფანჯარა</label>
        </div>
       </div>

    </div>

    <div class="mb-3" *ngIf="!form.get('isRedirect')?.value">
        <app-text-editor formControlName="content"></app-text-editor>
    </div>



    <!-- MENU PAGE MEDIA (ref_type=2) -->
<div class="mt-3 mb-3" *ngIf="!form.get('isRedirect')?.value">
  <!-- Upload only when we have menu page id -->
  <app-upload
    *ngIf="editingMenuPage"
    [uploadPath]="getMenuUploadPath()"
    (uploaded)="onFileUploaded($event)"
  ></app-upload>

  <div class="text-muted small mt-2" *ngIf="!editingMenuPage">
    ჯერ შეინახე მენიუ, შემდეგ გახსენი თავიდან და გამოჩნდება ატვირთვა.
  </div>
</div>

<!-- <div *ngIf="galleryItems?.length && !form.get('isRedirect')?.value" class="mt-3 mb-3">
  <label class="form-label mb-2">მიბმული ფაილები</label>

  <div
    cdkDropList
    [cdkDropListData]="galleryItems"
    (cdkDropListDropped)="dropGalleryImage($event)"
    class="d-flex flex-column gap-2"
  >
    <div
      class="border rounded p-2 d-flex align-items-start gap-2"
      *ngFor="let img of galleryItems; let i = index"
      cdkDrag
    >
      <button
        type="button"
        class="btn btn-sm btn-light border"
        cdkDragHandle
        title="გადაადგილება"
        style="cursor: grab; height: 42px; width: 42px; display:flex; align-items:center; justify-content:center;"
      >
        <i class="fi fi-rr-menu-burger"></i>
      </button>
 
      <div class="flex-shrink-0" style="width:42px; height:42px; display:flex; align-items:center; justify-content:center;">
        <ng-container *ngIf="isImageFile(img.url); else fileIcon">
          <img [src]="getFullImageUrl(img.url)" class="rounded" style="width:42px; height:42px; object-fit:cover;" />
        </ng-container>
        <ng-template #fileIcon>
          <i class="fi fi-rr-file" style="font-size:22px"></i>
        </ng-template>
      </div>

      <div class="flex-grow-1" style="min-width:0">

        <ng-container *ngIf="isImageFile(img.url); else fileActions">
          <div class="d-flex align-items-center justify-content-end" style="height:42px">
            <button
              class="btn btn-outline-danger btn-sm"
              type="button"
              (click)="removeGalleryImage(i)"
              title="წაშლა"
            >
              <i class="fi fi-rr-trash"></i>
            </button>
          </div>
        </ng-container>

    
        <ng-template #fileActions>
          <div class="input-group input-group-sm">
            <input
              class="form-control"
              placeholder="ფაილის სათაური"
              [(ngModel)]="img.title"
              [ngModelOptions]="{ standalone: true }"
              (blur)="saveMediaTitle(img)"
            />
            <button
              class="btn btn-outline-primary"
              type="button"
              (click)="saveMediaTitle(img)"
              title="შენახვა"
            >
              <i class="fi fi-rr-disk"></i>
            </button>

            <a
              class="btn btn-outline-success"
              [href]="getFullImageUrl(img.url)"
              target="_blank"
              rel="noopener"
              title="ჩამოტვირთვა"
            >
              <i class="fi fi-rr-download"></i>
            </a>

            <button
              class="btn btn-outline-danger"
              type="button"
              (click)="removeGalleryImage(i)"
              title="წაშლა"
            >
              <i class="fi fi-rr-trash"></i>
            </button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div> -->


<div class="card mt-3" *ngIf="editingMenuPage && imageItemsArr?.length && !form.get('isRedirect')?.value">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class="fw-bold">სურათები</div>
    <div class="text-muted small" *ngIf="sorting">სორტირება ინახება...</div>
  </div>

  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table table-bordered align-middle mb-0">
        <thead>
          <tr>
            <th style="width:60px;">#</th>
            <th style="width:60px;">⇅</th>
            <th style="width:90px;">Preview</th>
            <th>ფაილი</th>
            <th style="width:170px;">ქმედება</th>
          </tr>
        </thead>

        <tbody cdkDropList [cdkDropListData]="imageItemsArr" (cdkDropListDropped)="dropImages($event)">
          <tr *ngFor="let img of imageItemsArr; let i = index" cdkDrag>
            <td>{{ i + 1 }}</td>

            <td class="text-center">
              <button type="button" class="btn btn-sm btn-light border" cdkDragHandle title="გადაადგილება" style="cursor: grab;">
                <i class="fi fi-rr-menu-burger"></i>
              </button>
            </td>

            <td>
              <img
                [src]="getFullImageUrl(img.url || img.full_src || img.src)"
                style="width:70px;height:70px;object-fit:cover;border-radius:8px;border:1px solid #eee;" />
            </td>

            <td class="text-muted small">
              {{ img.title || img.orig_name || img.url }}
              <div class="text-muted" style="font-size:12px;">
                {{ img.url }}
              </div>
              <span class="badge bg-success ms-2" *ngIf="img.pin == 1">MAIN</span>
            </td>

            <td>
              <button class="btn btn-sm btn-outline-success me-2" (click)="setMainImage(img)">
                მთავარი
              </button>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeMedia(img, $event)">
              წაშლა
            </button>
            </td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>
</div>

<div class="alert alert-info mt-3" *ngIf="editingMenuPage && !imageItemsArr?.length && !form.get('isRedirect')?.value">
  სურათები ჯერ არ გაქვს დამატებული
</div>




<div class="card mt-3" *ngIf="editingMenuPage && !form.get('isRedirect')?.value">
  <div class="card-header d-flex align-items-center justify-content-between">
    <div class="fw-bold">ფაილები</div>
    <div class="text-muted small" *ngIf="sorting">სორტირება ინახება...</div>
  </div>

  <div class="card-body p-0">

    <div class="alert alert-info m-3" *ngIf="!fileItemsArr?.length">
      ფაილები ჯერ არ გაქვს დამატებული
    </div>

    <div class="table-responsive" *ngIf="fileItemsArr?.length">
      <table class="table table-bordered align-middle mb-0">
        <thead>
          <tr>
            <th style="width:60px;">#</th>
            <th style="width:60px;">⇅</th>
            <th>სათაური</th>
            <th style="width:220px;">ლინკი</th>
            <th style="width:220px;">ქმედება</th>
          </tr>
        </thead>

        <tbody cdkDropList [cdkDropListData]="fileItemsArr" (cdkDropListDropped)="dropFiles($event)">
          <tr *ngFor="let f of fileItemsArr; let i = index" cdkDrag>
            <td>{{ i + 1 }}</td>

            <td class="text-center">
              <button type="button" class="btn btn-sm btn-light border" cdkDragHandle title="გადაადგილება" style="cursor: grab;">
                <i class="fi fi-rr-menu-burger"></i>
              </button>
            </td>

            <td style="min-width:260px;">
              <input
                class="form-control form-control-sm"
                placeholder="ფაილის სათაური"
                [(ngModel)]="f.title"
                [ngModelOptions]="{ standalone: true }"
                (blur)="saveMediaTitle(f)"
              />
              <div class="text-muted small mt-1">
                {{ f.orig_name || f.url }}
              </div>
            </td>

            <td>
              <a class="btn btn-sm btn-outline-primary" [href]="getFullImageUrl(f.url)" target="_blank" rel="noopener">
                გახსნა
              </a>
            </td>

            <td>
            <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="renameFile(f, $event)">
              სახელის შეცვლა
            </button>

            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeMedia(f, $event)">
              წაშლა
            </button>
             
            </td>
          </tr>
        </tbody>

      </table>
    </div>

  </div>
</div>



    <div class="mt-3 mb-3" *ngIf="!form.get('isRedirect')?.value">
       <app-meta-modal [form]="form"></app-meta-modal>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">დახურვა</button>
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid || load">
      <span *ngIf="load" class="spinner-border spinner-border-sm"></span>
      შენახვა
    </button>
  </div>
</form>
